
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Tourcoing dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Tourcoing certifiée Google Partner, aide les entreprises tourquennoises à renforcer leur visibilité en ligne et attirer plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Tourcoing dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Tourcoing certifiée Google Partner, aide les entreprises tourquennoises à renforcer leur visibilité en ligne et attirer plus de clients.",
        },
      ],
    };
  },
};
